import { Typography } from '@mui/material';
import React from 'react'
import EventForm from '../components/EventForm/EventForm';

const NewEvent = () => {
  return (
    <div style={{padding: '10px'}}>
      <Typography variant="h4" textAlign={'center'} m="0 0 20px 0">Ùj esemény létrehozása</Typography>
      <EventForm />  
    </div>
  )
}

export default React.memo(NewEvent);